import React from 'react';
import { motion } from 'framer-motion';

const StatsCard = ({ title, value, icon: Icon, trend, trendValue, subtitle, tooltip, loading = false, compact = false }) => {
  if (compact) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-lg shadow p-3"
        title={tooltip || undefined}
      >
        <div className="flex items-start justify-between gap-2">
          <div className="flex-1 min-w-0">
            <p className="text-xs font-medium text-gray-600 truncate">{title}</p>
            {loading ? (
              <div className="h-6 w-16 bg-gray-200 animate-pulse rounded mt-1"></div>
            ) : (
              <p className="text-xl font-semibold text-gray-900 leading-tight mt-1 truncate">{value}</p>
            )}
            {(trendValue || subtitle) && (
              <p className="text-xs text-gray-500 truncate mt-0.5">
                {trendValue || subtitle}
              </p>
            )}
          </div>
          {Icon && (
            <div className="p-1.5 bg-primary-100 rounded-full flex-shrink-0">
              <Icon className="h-4 w-4 text-primary-600" />
            </div>
          )}
        </div>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-lg shadow p-4"
      title={tooltip || undefined}
    >
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-xs font-medium text-gray-600 h-8 flex items-center">{title}</p>
          {loading ? (
            <div className="h-8 w-20 bg-gray-200 animate-pulse rounded"></div>
          ) : (
            <p className="text-2xl font-semibold text-gray-900 h-8 flex items-center leading-none">{value}</p>
          )}
          {(trendValue || subtitle) && (
            <p className="text-xs text-gray-500 h-5 flex items-center">
              {trendValue || subtitle}
            </p>
          )}
        </div>
        {Icon && (
          <div className="p-2 bg-primary-100 rounded-full">
            <Icon className="h-5 w-5 text-primary-600" />
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default StatsCard;

